<div class="main-container">
  <div class="content-container">
    <div class="upper-container">
      <h1>{{ 'aiTroubleshoot.title' | cxTranslate }}</h1>
      <h3>{{ 'aiTroubleshoot.subtitle' | cxTranslate }}</h3>
      <p>{{ 'aiTroubleshoot.paragraph' | cxTranslate }}</p>
    </div>
    <div class="bottom-container">
      <div
        *ngIf="isApplianceFormActive$ | async"
        [@fadeOut]
        (@fadeOut.done)="onInitialApplianceFadeOutDone($event)"
        [@fadeIn]
      >
        <ng-template [ngTemplateOutlet]="applianceFormTemplate"></ng-template>
      </div>
      <div
        *ngIf="isChatActive$ | async"
        [@fadeIn]
        (@fadeIn.done)="onChatFadeInDone($event)"
        [@fadeOut]
        (@fadeOut.done)="isChatFadeOutDone($event)"
      >
        <ng-template [ngTemplateOutlet]="chatTemplate"></ng-template>
      </div>
    </div>
    <div
      class="disclaimer-container"
      *ngIf="isChatActive$ | async"
      [innerHTML]="'aiTroubleshoot.disclaimer' | cxTranslate"
      [@fadeIn]
    ></div>
  </div>
</div>

<ng-template #applianceFormTemplate>
  <div class="form-container">
    <form
      [formGroup]="applianceForm"
      (ngSubmit)="onApplianceFormSubmit($event)"
      id="appliance-form"
      name="appliance-form"
    >
      <div class="input-container form-group">
        <span
          class="info-popup"
          placement="right"
          container="body"
          [ngbPopover]="infoPopoverContent"
          popoverClass="info-tooltip"
          [triggers]="popoverTriggers"
        >
          <i class="fas fa-info-circle" aria-label="More information"></i>
        </span>

        <input
          [placeholder]="'aiTroubleshoot.enterAuidOrSn' | cxTranslate"
          type="text"
          value=""
          name="text"
          class="form-control-center"
          formControlName="text"
          aria-required="true"
        />
        <input class="btn-subscribe btn-round" type="submit" [value]="'aiTroubleshoot.select' | cxTranslate" />
      </div>
      <cx-form-errors
        aria-live="assertive"
        aria-atomic="true"
        [control]="$any(applianceForm).get('text')"
      ></cx-form-errors>
    </form>
  </div>
</ng-template>

<ng-template #chatTemplate>
  <div class="chat-box">
    <div class="messages-parent-container" #scrollContainer>
      <div class="messages-container">
        <ng-container *ngFor="let msg of messages$ | async">
          <div
            [ngClass]="{
              'message-box-container': msg.from === 'bot',
              'message-box-container-user': msg.from === 'user',
              faq: msg.type === 'faq',
            }"
          >
            <div *ngIf="msg.type === 'text'" class="message-box" @fadeInUp>
              {{ msg.text$ | async }}
            </div>

            <div *ngIf="msg.type === 'faq'" class="message-box faq-box" @fadeInUp>
              <div class="faq-header">
                <div class="faq-title">
                  {{ msg.title }}
                </div>
                <div class="faq-status-container">
                  <div class="faq-status" [ngClass]="msg.statusEnum">
                    {{ msg.status$ | async }}
                  </div>
                  <div class="expand-caret" (click)="toggleFaq(msg)"><i class="arrow down"></i></div>
                </div>
              </div>
              <div class="faq-body" *ngIf="msg.expanded">
                <markdown [data]="msg.text"></markdown>
              </div>
            </div>
          </div>
        </ng-container>
        <div class="is-typing" *ngIf="isBotTyping$ | async">
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
    </div>

    <ng-container *ngIf="isTryAgainApplianceForm$ | async">
      <ng-template [ngTemplateOutlet]="tryAgainApplianceFormTemplate"></ng-template>
    </ng-container>

    <ng-container *ngIf="isIssueDescriptionForm$ | async">
      <ng-template [ngTemplateOutlet]="issueDescriptionFormTemplate"></ng-template>
    </ng-container>

    <ng-container *ngIf="isIssueResolved$ | async">
      <ng-template [ngTemplateOutlet]="issueResolvedTemplate"></ng-template>
    </ng-container>
  </div>
</ng-template>

<ng-template #tryAgainApplianceFormTemplate>
  <form
    [@fadeIn]
    [@fadeOut]
    (@fadeOut.done)="onTryAgainApplianceFormFadeOutDone($event)"
    [formGroup]="applianceForm"
    (ngSubmit)="onTryAgainApplianceFormSubmit($event)"
    id="try-again-appliance-form"
    name="try-again-appliance-form"
  >
    <div class="input-container form-group">
      <input
        [placeholder]="'aiTroubleshoot.enterAuidOrSn' | cxTranslate"
        type="text"
        value=""
        name="text"
        class="form-control-center dark-text"
        formControlName="text"
        aria-required="true"
      />
      <input
        class="btn-round btn-primary"
        type="submit"
        [value]="'aiTroubleshoot.tryAgain' | cxTranslate"
        [disabled]="!(areMessagesLoaded$ | async) || (isBotTyping$ | async)"
      />
    </div>
    <cx-form-errors
      aria-live="assertive"
      aria-atomic="true"
      [control]="$any(applianceForm).get('text')"
      class="dark-error"
    ></cx-form-errors>
  </form>
</ng-template>

<ng-template #issueDescriptionFormTemplate>
  <form
    [@fadeIn]
    [@fadeOut]
    (@fadeOut.done)="issueDescriptionFormFadeOutDone($event)"
    [formGroup]="issueForm"
    (ngSubmit)="onIssueFormSubmit($event)"
    id="issue-description-form"
    name="issue-description-form"
  >
    <div class="input-container form-group">
      <input
        [placeholder]="'aiTroubleshoot.describeIssue' | cxTranslate"
        type="text"
        value=""
        name="text"
        class="form-control-center dark-text"
        formControlName="text"
        aria-required="true"
      />
      <input
        class="btn-round btn-primary"
        type="submit"
        [value]="'aiTroubleshoot.send' | cxTranslate"
        [disabled]="!(areMessagesLoaded$ | async) || (isBotTyping$ | async)"
      />
    </div>
    <cx-form-errors
      aria-live="assertive"
      aria-atomic="true"
      [control]="$any(issueForm).get('text')"
      class="dark-error"
    ></cx-form-errors>
  </form>
</ng-template>

<ng-template #issueResolvedTemplate>
  <div class="issue-resolved-btn-container" [@fadeIn] [@fadeOut] (@fadeOut.done)="issueResolvedFadeOutDone($event)">
    <input
      class="btn-round btn-primary btn-margin"
      type="submit"
      [value]="'aiTroubleshoot.issueResolved' | cxTranslate"
      (click)="resetToFirstStep()"
      [disabled]="!(areMessagesLoaded$ | async) || (isBotTyping$ | async)"
    />
    <input
      class="btn-round btn-border btn-margin"
      type="submit"
      [value]="'aiTroubleshoot.tryAgain' | cxTranslate"
      (click)="tryAgainIssueDescriptionSubmit()"
      [disabled]="!(areMessagesLoaded$ | async) || (isBotTyping$ | async)"
    />
  </div>
</ng-template>

<ng-template #infoPopoverContent>
  <div class="info-popup-container">
    <h3>{{ 'aiTroubleshoot.infoTitle' | cxTranslate }}</h3>
    <div class="info-popup-body">
      {{ 'aiTroubleshoot.infoText' | cxTranslate }}
    </div>
    <img [src]="'aiTroubleshoot.infoImg' | cxTranslate" alt="" class="info-popup-img" />
  </div>
</ng-template>
